export default {
  defaultProjectImage: '/img/placeholders/sirius-project-bg-X.jpg',
  defaultToolImage: '/img/default-tool.png',
  defaultLanguageImage: '/img/default-tool.png',
  defaultConferenceImage: '/img/default-conference.png',
  defaultEducationImage: '/img/default-education.png',
  maxLanguagesTools: 20,
  maxProjects: 20,
  mobileBreakpoint: 768,
  notificationSettings: {
    toast: true,
    position: 'top-end',
    timer: 3000,
    showConfirmButton: false
  },
  pdfTemplates: {
    classic: 0,
    simple: 1,
    contemporary: 2
  },
  // for logos with landscape aspect ratio
  wideLogos: [
    'sap@2x.svg'
  ]
}
